import React, { useContext } from "react";
import GratefulDB from "../../GratefulDB";
import GratefulDBContext from "../../GratefulDBContext";
import EntryImage from "../shared/EntryImage";
import MaxWidthLabel from "../shared/MaxWidthLabel";
import { useNavUtils } from "../shared/useNavUtils";
import "./HomeScreen.scss";

const HomeScreen: React.FC = (): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const SBD = require(`../../images/${process.env.REACT_APP_SBD_IMAGE}`);
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const Hero = require(`../../images/${process.env.REACT_APP_HERO_IMAGE}`);

  const navUtils = useNavUtils();

  const gratefulDB = useContext<GratefulDB>(GratefulDBContext);
  const top10ByYear = gratefulDB.getTop10ByYear();

  const hero = (
    <div className="hero">
      <div className="ui container grid">
        <div className="four wide column computer only">
          <img
            className="ui image right floated jerry"
            src={Hero}
            alt="Garcia the Great!"
          />
        </div>
        <div className="sixteen wide mobile sixteen wide tablet ten wide computer column">
          <div className="ui horizontal equal width segments">
            <div className="ui center aligned padded segment">
              <div className="ui icon header">
                <i className="search icon" />
                Search the catalog
                <div className="sub header">
                  You can use full text search by song name or show date.{" "}
                  <i>(YYYY-MM-DD)</i>
                </div>
              </div>
            </div>
            <div className="ui padded segment time-machine mobile-hidden">
              <div className="ui icon header">
                <i className="clock link icon" onClick={navUtils.timeMachine} />
                Explore the time machine
                <div className="sub header">
                  Spin one of the dials to explore the catalog.
                </div>
              </div>
            </div>
            <div className="ui padded radio-player segment">
              <div className="ui icon header">
                <i
                  className="compact disc link icon"
                  onClick={navUtils.radio}
                />
                Try the virtual radio player
                <div className="sub header">
                  Pick an era, sit back and let the algorithm decide.
                </div>
              </div>
            </div>
            {process.env.REACT_APP_HOME_SHOW_SOURCE === "true" ? (
              <div className="ui padded segment mobile-hidden">
                <div className="ui icon header">
                  <i className="server icon" />
                  Archive.org is indexed at load
                  <div className="sub header">
                    There is no backend. This is a static website.
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="ui HomeScreen">
      {hero}
      {Object.keys(top10ByYear).map((year) => {
        const top10 = top10ByYear[year];
        return top10 ? (
          <div key={year}>
            <h2 className="ui horizontal section divider header">{year}</h2>
            <div className="ui container grid">
              <div className="twelve wide mobile fourteen wide tablet fourteen wide computer column">
                <div className="ui cards">
                  {top10.map((result, index) => (
                    <div
                      className={`ui centered card link ${
                        index >= 1 ? "mobile-hidden" : null
                      }`}
                      onClick={() => navUtils.show(result.identifier)}
                      key={result.identifier}
                    >
                      <div className="content">
                        {result.image ? (
                          <div className="right floated ui image">
                            <EntryImage image={result.image} />
                          </div>
                        ) : (
                          <img
                            className="right floated mini ui image"
                            src={SBD}
                            alt="SBD"
                          />
                        )}
                        <div className="header">{result.date}</div>
                        <div className="meta">
                          {result.venue}, {result.coverage}
                        </div>
                        <div className="description">
                          <MaxWidthLabel label={result.transferer} width={40} />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="four wide mobile two wide tablet two wide computer middle aligned column">
                <button
                  className="ui white massive circular icon button"
                  onClick={() => navUtils.year(year)}
                >
                  <i className="angle double right icon" />
                  <br />
                </button>
              </div>
            </div>
          </div>
        ) : null;
      })}
    </div>
  );
};

export default HomeScreen;
